export const DEFAULT_TRANSLATION = 'en-US';
export const FLAGS_CDN_URL = 'https://cf.mailmunch.com/locale_flags';